import Vue from 'vue'

export default {
  namespaced: true,

  state: {
    items: []
  },

  getters: {
    items: state => {
        return state.items
    }
  },

  mutations: {
    setItems (currentState, items) {
        currentState.items = items
    },
    addItem (currentState, item) {
        currentState.items.push(item)
    },
    updateItem (currentState, item) {
        for (var i = 0; i < currentState.items.length; i++) {
            if (currentState.items[i]._id === item._id) {
              Vue.set(currentState.items, i, item)
            }
          }
    }
  },

  actions: {
    fetch: ({commit, state}, data) => {
        let params = data || {};

        let uri = '/account/' + data.uuid + '/'
        return new Promise((resolve, reject) => {
            Vue.axios.get(uri, {params: params})
                .then(res => {
                    commit('setItems', res.data)
                    resolve(res.data)
                })
                .catch(err => {
                    console.log(err)
                })
        })
    },
    create: ({commit, state}, {data}) => {
        let uri = '/projects'
        return new Promise((resolve, reject) => {
            Vue.axios.post(uri, data)
                .then(res => {
                    commit('addItem', res.data)
                    resolve(res.data)
                })
                .catch(err => {
                    console.log(err)
                })
        })
    },
    read: (context, id) => {
        let uri = '/projects/' + id
        return new Promise((resolve, reject) => {
            Vue.axios.get(uri)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    console.log(err)
                })
          })
    },
    update: ({commit, state}, {data}) => {
        let uri = '/users/' + data.id

        return new Promise((resolve, reject) => {
            Vue.axios.put(uri, data)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    console.log(err)
                })
        })
    },
    updateAddress: ({commit, state}, {data}) => {
        let uri = '/users/' + data.id + '/address'

        return new Promise((resolve, reject) => {
            Vue.axios.put(uri, data)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    updatePassword: ({commit, state}, {data}) => {
        let uri = '/users/password'

        return new Promise((resolve, reject) => {
            Vue.axios.post(uri, data)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    } 
  }
}



//////////////////
// WEBPACK FOOTER
// ./prompts/store/modules/User.js
// module id = null
// module chunks = 